import { render, staticRenderFns } from "./JustificatifButton.vue?vue&type=template&id=4a0e0ca4&"
import script from "./JustificatifButton.vue?vue&type=script&lang=js&"
export * from "./JustificatifButton.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports